import{ Box } from '@mui/material'

const AppBar=({title})=>{
    
    return(
        <Box 
        sx={{width:"100%",
            height:'10vh',
            backgroundColor: title === 'red' ? 'red' : 'blue',}}>

        </Box>
    )
}

export default AppBar;